/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Case_Payment_Policy_Interest_FreeInputs */

const en_case_payment_policy_interest_free = /** @type {(inputs: Case_Payment_Policy_Interest_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Interest-free: up to ${i?.count} installments.`)
};

const pt_br2_case_payment_policy_interest_free = /** @type {(inputs: Case_Payment_Policy_Interest_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem juros: até ${i?.count} parcelas.`)
};

/**
* | output |
* | --- |
* | "Interest-free: up to {count} installments." |
*
* @param {Case_Payment_Policy_Interest_FreeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_policy_interest_free = /** @type {((inputs: Case_Payment_Policy_Interest_FreeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Policy_Interest_FreeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_policy_interest_free(inputs)
	return pt_br2_case_payment_policy_interest_free(inputs)
});